import React, {useState, useEffect, useContext} from 'react';
import {BrandContext} from "@context/BrandContext";
import {TemplateContext} from "@context/TemplateContext";
import DefaultFooter from "./DefaultFooter";

const Footer = props => {
    const {footerComponentName} = useContext(TemplateContext);
    const brandConfig = useContext(BrandContext);
    const {callback} = props;

    const footerComponents = {DefaultFooter: DefaultFooter};
    const FooterComponent = footerComponentName === undefined ? undefined : footerComponents[footerComponentName];

    if(FooterComponent === undefined) {
        return null;
    }

    return (
        <FooterComponent/>
    )
}

export default Footer;